import styled from 'styled-components';

const RecoverWrapper = styled.div`
  min-height: calc(100vh - 280px);
	max-width: 600px;
	margin: 30px auto;
	padding: 10px 30px;
`;

export {
	RecoverWrapper
}